import { render, staticRenderFns } from "./aboutPage.vue?vue&type=template&id=8ea877f4&"
import script from "./aboutPage.vue?vue&type=script&lang=js&"
export * from "./aboutPage.vue?vue&type=script&lang=js&"
import style0 from "./aboutPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports